import React from "react";
import nextId from "react-id-generator";
import RangeSlider from "../../../../Common/RangeSlider/RangeSlider";
import "./job-listing-sidebar.style.scss";
export default function JobListingSidebar({ filterConfig, setFilterConfig }) {
  const [currentList, setCurrentList] = React.useState([]);

  const [localFilter, setLocalFilter] = React.useState({
    jobTitle: "",
    city: "",
    country: "",
    jobCategory: "",
    custField4: "",
    jobDescription: "",
    start: "1",
    numOfRecords: "9",
    websitePublish: "",
    custField1: [""],
    jobType: [""],
    minSalary: "0",
    maxSalary: "1000000",
  });

  const handleClick = (obj) => {
    if (currentList.includes(obj.keyId)) {
      let temp = currentList.filter((x) => {
        return x !== obj.keyId;
      });
      setCurrentList([...temp]);
    } else {
      setCurrentList([...currentList, obj.keyId]);
    }
  };
  const checkedClick = (obj, other) => {
    switch (obj.id) {
      case "curr":
        let temp = filterConfig.custField1;
        let check = temp[0];
        if (!check) {
          setFilterConfig({
            ...filterConfig,
            start: "1",
            custField1: [other.name],
          });
        } else {
          if (temp.includes(other.name)) {
            let tempArr = temp.filter((x) => {
              return x !== other.name;
            });
            if (!tempArr.length) {
              setFilterConfig({
                ...filterConfig,
                start: "1",
                custField1: [""],
              });
            } else {
              setFilterConfig({
                ...filterConfig,
                start: "1",
                custField1: [...tempArr],
              });
            }
          } else {
            setFilterConfig({
              ...filterConfig,
              start: "1",
              custField1: [...filterConfig.custField1, other.name],
            });
          }
        }

        break;

      case "type":
        let tempOne = filterConfig.jobType;
        let checkOne = tempOne[0];
        if (!checkOne) {
          setFilterConfig({ ...filterConfig, jobType: [other.name] });
        } else {
          if (tempOne.includes(other.name)) {
            let tempArr = tempOne.filter((x) => {
              return x !== other.name;
            });
            if (!tempArr.length) {
              setFilterConfig({
                ...filterConfig,
                jobType: [""],
              });
            } else {
              setFilterConfig({
                ...filterConfig,
                jobType: [...tempArr],
              });
            }
          } else {
            setFilterConfig({
              ...filterConfig,
              jobType: [...filterConfig.jobType, other.name],
            });
          }
        }

        break;
      default:
        break;
    }
  };
  const checkSelected = (obj, other) => {
    switch (obj.id) {
      case "curr":
        let temp = filterConfig.custField1;
        if (temp.includes(other.name)) {
          return true;
        } else {
          return false;
        }
        break;

      case "type":
        let tempOne = filterConfig.jobType;
        if (tempOne.includes(other.name)) {
          return true;
        } else {
          return false;
        }
        break;
        break;
      default:
        break;
    }
  };
  React.useEffect(() => {
    setLocalFilter({ ...localFilter, ...filterConfig });
  }, [filterConfig]);

  return (
    <aside
      onClick={(e) => e.stopPropagation()}
      className="job-listing-sidebar-main"
    >
      <header className="jlsm-header">
        <h6>Filter</h6>
        <p
          onClick={() => {
            setLocalFilter({ ...schema });
            setFilterConfig({ ...schema });
          }}
        >
          Clear all
        </p>
      </header>
      <div className="jlsm-body">
        <div className="jlsm-inputs">
          <div className="input-wrapper">
            <h6>Location</h6>
            <input
              onChange={(e) =>
                setLocalFilter({
                  ...localFilter,
                  city: e.target.value,
                })
              }
              onBlur={() => {
                setFilterConfig({
                  ...filterConfig,
                  start: "1",
                  city: localFilter.city,
                });
              }}
              onKeyPress={(e) => {
                e.which === 13
                  ? setFilterConfig({
                      ...filterConfig,
                      start: "1",
                      city: localFilter.city,
                    })
                  : console.log();
              }}
              value={localFilter.city}
              placeholder="area, city, country"
            />
          </div>
          <div className="input-wrapper">
            <h6>Job Title</h6>
            <input
              onChange={(e) =>
                setLocalFilter({
                  ...localFilter,
                  jobTitle: e.target.value,
                })
              }
              onBlur={() => {
                setFilterConfig({
                  ...localFilter,
                  start: "1",
                  jobTitle: localFilter.jobTitle,
                });
              }}
              onKeyPress={(e) => {
                e.which === 13
                  ? setFilterConfig({
                      ...filterConfig,
                      start: "1",
                      jobTitle: localFilter.jobTitle,
                    })
                  : console.log();
              }}
              value={localFilter.jobTitle}
              placeholder="Job title"
            />
          </div>
        </div>
        <div className="dropdowns-wrapper">
          {dropdownList.map((obj, num) => (
            <div className="single-dropdown">
              <div
                onClick={() => handleClick(obj, num)}
                className="dropdown-title"
              >
                <span>{obj.title}</span>
                <img
                  className="arrow-down"
                  src="https://img.icons8.com/material-sharp/50/000000/sort-down.png"
                />{" "}
              </div>
              <ul
                style={
                  currentList.includes(obj.keyId)
                    ? { height: `${obj.list.length * 35}px` }
                    : {}
                }
                className="drop-list-wrapper"
              >
                {obj.list.map((x) => (
                  <li
                    onClick={() => {
                      checkedClick(obj, x);
                    }}
                    key={x.keyId}
                  >
                    <input checked={checkSelected(obj, x)} type="checkbox" />
                    <span>{x.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <RangeSlider
          handleMinValue={(x) =>
            setFilterConfig({ ...filterConfig, minSalary: x })
          }
          handleMaxValue={(x) =>
            setFilterConfig({ ...filterConfig, maxSalary: x })
          }
        />
      </div>
    </aside>
  );
}
const dropdownList = [
  {
    keyId: nextId(),
    title: "Job Type",
    id: "type",
    list: [
      { keyId: nextId(), name: "Full Time" },
      { keyId: nextId(), name: "Part Time" },
    ],
  },
  {
    keyId: nextId(),
    title: "Curriculum",
    id: "curr",
    list: [
      { keyId: nextId(), name: "CBSE" },
      { keyId: nextId(), name: "ICSE " },
      { keyId: nextId(), name: "IGCSE" },
      { keyId: nextId(), name: "PU" },
      { keyId: nextId(), name: "IB" },
      { keyId: nextId(), name: "Higher Education" },
    ],
  },
  // {
  //   keyId: nextId(),
  //   title: "Class",
  //   list: [
  //     { keyId: nextId(), name: "1 - IV" },
  //     { keyId: nextId(), name: "V - VII" },
  //     { keyId: nextId(), name: "VII - X" },
  //   ],
  // },
];
const schema = {
  jobTitle: "",
  city: "",
  country: "",
  jobCategory: "",
  custField4: "",
  jobDescription: "",
  start: "1",
  numOfRecords: "9",
  websitePublish: "",
  custField1: [""],
  jobType: [""],
  minSalary: "0",
  maxSalary: "100000000",
};
